import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { config } from 'src/config';
import { useNonce } from 'src/shared/hooks';
import { getUtmCookies } from 'src/shared/utils/cookie';
import { isBrowser } from 'src/shared/utils/environment';

import { snippet } from './snippet';

let middlewareInitialized = false;
const appContext = {
  name: config.APPLICATION_NAME,
  version: config.VERSION,
};

const Segment = () => {
  const nonce = useNonce();

  useEffect(() => {
    if (!middlewareInitialized && isBrowser() && window.analytics) {
      middlewareInitialized = true;
      // Enrich all events with metadata about the web application
      void window.analytics.addSourceMiddleware(({ payload, next }) => {
        const { obj } = payload;
        let { context } = obj;
        if (!context) {
          context = {};
          obj.context = context;
        }

        const { utmCampaign, utmSource, utmMedium, utmContent, utmTerm } =
          getUtmCookies();
        if (utmCampaign || utmSource || utmMedium) {
          context.campaign = {
            name: utmCampaign ?? '',
            source: utmSource ?? '',
            medium: utmMedium ?? '',
            content: utmContent ?? '',
            term: utmTerm ?? '',
          };
        }

        context.app = {
          ...appContext,
          // events can potentially enrich `app` with more info
          ...context.app,
        } as Record<string, unknown>;

        next(payload);
      });
    }
  }, []);

  if (!config.SEGMENT_API_KEY || (isBrowser() && window?.analytics)) {
    return null;
  }

  return (
    <Helmet>
      <script nonce={nonce}>{snippet(config.SEGMENT_API_KEY)}</script>
    </Helmet>
  );
};

export { Segment };
